<portal-filter-wrapper>
  <div class="control">
    <portal-dashboard-date-range
      [labelName]="dateRange"
      [quickPicks]="dateRangeQuickPicksList"
      [selectedEntities]="searchCriteriaDateRange"
      [isCompareType]="false"
      [isValidDiffLength]="isValidDateRange"
      [isValidDateFrom]="isValidDateRangeFrom"
      [isNewDesignFilter]="isNewDesignFilter"
      [showQuickPicks]="showQuickPicks"
      [showTimePicker]="true"
      (quickPickApplied)="onDateRangeQuickPickApplied($event)"
      (filterApplied)="onDateRangeFilterApplied($event)"
      (customSelection)="onCustomSelectionDateRange($event)"
      (fromDateSelection)="onCustomSelectionFromDateRange($event)"
      (itemToggled)="onDateFilterToggled()"
    >
    </portal-dashboard-date-range>
  </div>
  <div class="control">
    <portal-dashboard-date-range
      [isCheckboxDisabled]="isCheckboxDisabled"
      [labelName]="compareTo"
      [quickPicks]="compareToQuickPicksList"
      [selectedEntities]="searchCriteriaCompareTo"
      [isCompareType]="true"
      [isCheckedDefault]="isCompareToBoxChecked"
      [isValidDiffLength]="isValidDiffLength"
      [isDateRangesOverlapping]="isDateRangesOverlapping"
      [dateRangeSelection]="dateRangeSelection"
      [isValidDateFrom]="isValidDateCompareTo"
      [isNewDesignFilter]="isNewDesignFilter"
      [markDisabled]="isDisabled"
      [showQuickPicks]="showQuickPicks"
      [showTimePicker]="true"
      (checkedUpdated)="onCompareToCheckedUpdated($event)"
      (quickPickApplied)="onCompareToQuickPickApplied($event)"
      (filterApplied)="onCompareToFilterApplied($event)"
      (customSelection)="onCustomSelectionCompareTo($event)"
      (fromDateSelection)="onCustomSelectionFromDateCompareTo($event)"
      (itemToggled)="onDateFilterToggled()"
    >
    </portal-dashboard-date-range>
  </div>
</portal-filter-wrapper>
